import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppSession } from 'src/app/models/app-session';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  minPasswordLength = AppSession.getPasswordPolicy().minLength;
  maxPasswordLength = AppSession.getPasswordPolicy().maxLength;
  minPasswordUppercase = AppSession.getPasswordPolicy().minUppercase;
  minPasswordLowercase = AppSession.getPasswordPolicy().minLowercase;
  minPasswordDigits = AppSession.getPasswordPolicy().minDigits;
  minPasswordHistory = AppSession.getPasswordPolicy().minHistory;
  minPasswordSymbols = AppSession.getPasswordPolicy().minSymbols;

  minPasswordLengthText = this.minPasswordLength;
  maxPasswordLengthText = this.maxPasswordLength;
  minPasswordUppercaseText = this.minPasswordUppercase;
  minPasswordLowercaseText = this.minPasswordLowercase;
  minPasswordDigitsText = this.minPasswordDigits;
  minPasswordHistoryText = this.minPasswordHistory;
  minPasswordSymbolsText = this.minPasswordSymbols;

  constructor(public translate: TranslateService) {}

  ngOnInit() {
  }
}
